const logo = `<svg xmlns="http://www.w3.org/2000/svg" height="23px" viewBox="0 0 690 433">
    <g fill-rule="evenodd">
        <g transform="translate(0 .5)">
            <ellipse cx="336.707" cy="105.831" rx="105.004" ry="105.398"/>
            <path d="M663 304.916v126.65H0v-126.65z"/>
        </g>
    </g>
</svg>
`;

export default logo;
